import { render, staticRenderFns } from "./insect_analyze.vue?vue&type=template&id=b8ce2716&"
import script from "./insect_analyze.vue?vue&type=script&lang=js&"
export * from "./insect_analyze.vue?vue&type=script&lang=js&"
import style0 from "./insect_analyze.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports